// ====================================================================
// PRICING CONFIG — Woodstone Construction
// --------------------------------------------------------------------
// Internal per-m² rates. These are NEVER shown to the customer.
// The calculator multiplies the area by the low/high values to produce
// an estimated total range.
//
// To update pricing, edit the numbers below and save. Hot reload will
// pick them up automatically.
// ====================================================================

export const PRICING = {
  composite: {
    label: "Composite decking",
    minPerSqm: 250,
    maxPerSqm: 360,
    description:
      "Low-maintenance, UV-stable composite boards. Ideal for busy households and high-sun Melbourne backyards.",
  },
  merbau: {
    label: "Merbau decking",
    minPerSqm: 280,
    maxPerSqm: 350,
    description:
      "Premium Australian hardwood with a rich, natural finish. Needs periodic oiling to retain its warm colour.",
  },
};

// Surface modifier notes (informational only — does not change price today)
export const SURFACE_NOTES = {
  concrete: "Existing concrete slab — faster install, fewer framing requirements.",
  soil: "Soil / grass — may require extra sub-frame work, footings, and ground prep.",
};

// Range rounding step for the displayed estimate (rounds to nearest $50)
export const ROUND_TO = 50;
